import * as types from './action-types';
import services from '../../../../services';
import selectors from './state-selectors';
import loanSelectors from '../../../../selectors/loan';
import util from '../../../../util';

const loanSelector = loanSelectors.loanSelector;
const api = services.coreAPIInstance;

const pullCreditUnfreeze = () => ({
    asyncAction: () => api.pullCreditUnfreeze(),
    type: types.PULL_CREDIT,
});

const pullCredit = () => (dispatch, getState) => {
    dispatch(pullingCredit());
    const loanId = loanSelector.getLoanId(getState());
    return api.pullCredit(loanId)
        .then((response) => dispatch(succeededPullingCredit(response)))
        .then(() => handleRouting(getState()))
        .catch((error) => {
            dispatch(failedPullingCredit(error));
        });
};

const handleRouting = function (state) {
    const loanStatusCode = loanSelector.getStatusCode(state);
    const reportStatus = selectors.getCode(state);
    if (reportStatus === 'CREDIT_PULL_SUCCESS') {
        loanStatusCode === 400 ? util.router.route('loan-overview') : util.router.route('loan-options/');
        return;
    }

    setCreditFreezeAttemptsInStorage();
    // Remove the `#` and any leading `/` for accurate comparison
    const currentRoute = window.location.hash.replace(/^#\/?/, '');
    const routeMap = {
        'CREDIT_NOHIT_FREEZE_EQ_TU': 'credit-freeze',
        'CREDIT_NOHIT_FREEZE': 'credit-freeze-eq',
        'CREDIT_NOHIT_FREEZE_TU': 'credit-freeze-tu'
    };
    const targetRoute = routeMap[reportStatus];
    // Only route if the target is different from the current route
    if (targetRoute && currentRoute !== `${targetRoute}`) {
        util.router.route(targetRoute);
    }
};

const reset = () => ({
    type: types.PULL_CREDIT_RESET,
});

export const pullingCredit = () => ({
    type: types.PULL_CREDIT_PENDING
});

export const failedPullingCredit = (error) => ({
    type: types.PULL_CREDIT_FAILURE,
    error: error
});

export const succeededPullingCredit = (response) => ({
    type: types.PULL_CREDIT_SUCCESS,
    res: {
        code: response.status
    }
});

function setCreditFreezeAttemptsInStorage () {
    const failureData = JSON.parse(localStorage.getItem('creditFailureData')) || { count: 0, timestamp: Date.now() };
    const currentTime = Date.now();
    const oneHour = 60 * 60 * 1000;
    if (currentTime - failureData.timestamp > oneHour) {
        failureData.count = 0;
        failureData.timestamp = currentTime;
    }
    failureData.count += 1;
    localStorage.setItem('creditFailureData', JSON.stringify(failureData));
}

export default {
    pullCreditUnfreeze,
    pullCredit,
    reset
};
